module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.6373/js/img/productIcons/Sales_Starter_white.svg"